import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KPIS = [
  ["visitors", "Website Visitors"],
  ["applications", "Artist Applications"],
  ["booking_clicks", "Booking Clicks"],
  ["sessions_booked", "Sessions Booked"],
  ["partnership_enquiries", "Partnership Enquiries"],
  ["skool_clicks", "Skool Clicks"],
  ["email_signups", "Email Sign-ups"],
  ["contact_enquiries", "Contact Enquiries"],
  ["roadmap_leads", "Roadmap Leads"],
  ["roadmaps_generated", "Roadmaps Generated"],
];

const FUNNEL = [
  ["visitors", "Visitor"],
  ["leads", "Lead"],
  ["sessions", "Session"],
  ["partnerships", "Partnership"],
];

export default function Dashboard() {
  const [m, setM] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/metrics`);
      setM(data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white font-body px-6 lg:px-10 py-12" data-testid="dashboard-page">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-[13px] tracking-[0.1em] uppercase mb-4 transition-colors" data-testid="dashboard-back">
              <ArrowLeft size={15} /> Back to site
            </Link>
            <h1 className="font-heading uppercase tracking-tight text-4xl lg:text-5xl">KPI Dashboard</h1>
            <p className="text-white/45 mt-2 text-[14px]">TAPSS ecosystem — the numbers that matter.</p>
          </div>
          <button onClick={load} className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/20 text-[12px] tracking-[0.12em] uppercase hover:bg-white/10 transition-colors" data-testid="dashboard-refresh">
            <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Refresh
          </button>
        </div>

        {m && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
              {KPIS.map(([k, label]) => (
                <div key={k} className="bg-[#050505] p-7" data-testid={`kpi-${k}`}>
                  <div className="font-heading text-4xl lg:text-5xl tracking-tight text-gold">{m[k] ?? 0}</div>
                  <div className="text-[11px] tracking-[0.16em] uppercase text-white/45 mt-2">{label}</div>
                </div>
              ))}
            </div>

            <div className="mt-14">
              <p className="text-[11px] tracking-[0.2em] uppercase text-white/40 mb-6">Conversion funnel</p>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {FUNNEL.map(([k, label], i) => (
                  <div key={k} className="rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.05] to-transparent p-7" data-testid={`funnel-${k}`}>
                    <span className="font-serif-accent italic text-white/30 text-xl">{String(i + 1).padStart(2, "0")}</span>
                    <div className="font-heading text-3xl tracking-tight mt-3 text-gold">{m.funnel?.[k] ?? 0}</div>
                    <div className="text-[12px] tracking-[0.14em] uppercase text-white/45 mt-1">{label}</div>
                  </div>
                ))}
              </div>
              <p className="text-white/30 text-[12px] mt-6">Visitor → Lead → Session → Partnership → Revenue</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
